import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/search.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-22d3efb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter" }
const _hoisted_2 = { class: "filter-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "filter-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.search) = $event)),
        placeholder: "Поиск.."
      }, null, 512), [
        [_vModelText, _ctx.filter.search]
      ]),
      _createElementVNode("button", {
        class: "filter-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFilterChanged()))
      }, _hoisted_4)
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}